(() => {
  if (window.sn17GlobalReady) return; window.sn17GlobalReady = true;
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-sn17-scroll]');
    if (!button) return;
    const track = button.closest('[data-sn17-rail]')?.querySelector('[data-sn17-track]');
    if (track) track.scrollBy({left: track.clientWidth * Number(button.dataset.sn17Scroll), behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
  });
})();
